import React from "react";
import { Box } from "@material-ui/core";
import OtpTable from "../../table/otpTable";
import WithDatesSearch from "../../../../../components/search/withDatesSearch";

export default function OtpPanelComponent({
  handleSearch,
  handleChangePage,
  handleChangeRowsPerPage,
  changeOrder
}) {
  return (
    <Box pt={2}>
      <WithDatesSearch
        handleFilter={(value) => {
          handleSearch(value);
        }}
      >
      </WithDatesSearch>
      <OtpTable
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        changeOrder={changeOrder}
      />
    </Box>
  );
}
